import {PersonLike} from '@lib/infrastructure';
import {getGroupWithWorkdayCountByDate, useAppSelector} from '@lib/store';
import {AddGroupMembersSectionItem} from './AddGroupMembersSectionItem';
import {useTranslation} from 'react-i18next';
import {animated} from '@react-spring/web';
import {config, useTransition} from 'react-spring';
import {LocalDateString} from '@lib/store/src/data/timeslots/apiTypes';

export const AddGroupMembersSection = ({
  onSelect,
  show,
  dateKey,
}: {
  onSelect: (invitees: PersonLike[], groupId: string) => void;
  show: boolean;
  dateKey: LocalDateString;
}) => {
  const {t} = useTranslation();
  const currentUserId = useAppSelector((state) => state.data.user.user.id);

  // Filter out groups where the current user is the only member
  const groups = useAppSelector((state) => getGroupWithWorkdayCountByDate(state, dateKey)).filter(
    (group) => !group.members.every((member) => member.user.id === currentUserId),
  );

  const transitions = useTransition(show, {
    delay: 100,
    initial: {opacity: 1, transform: 'translate3d(0, 0px, 0) scale(1)'},
    from: {opacity: 0, transform: 'translate3d(0, 10px, 0) scale(1)'},
    enter: {opacity: 1, transform: 'translate3d(0, 0px, 0) scale(1)'},
    leave: {opacity: 0, transform: 'translate3d(0, 10px, 0) scale(1)'},
    config: config.stiff,
  });

  if (groups.length === 0) {
    return null;
  }

  return transitions(
    (style, item) =>
      item && (
        <animated.div
          style={{...style}}
          className="grid gap-4">
          <h4>{t('groups:Booking.SectionTitle')}</h4>
          <div className="divide-y">
            {groups.map((group) => (
              <AddGroupMembersSectionItem
                key={group.id}
                onSelect={onSelect}
                group={group}
              />
            ))}
          </div>
        </animated.div>
      ),
  );
};
